// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.VSslt7 {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  border-radius: 8px;
  background-color: var(--surface-neutral-white);
  box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.12);
}

.JSTrZu {
  display: flex;
  padding: 0 16px 0 12px;
  box-shadow: inset 0 -1px 0 var(--line-subtle, #f2f2f2);
  justify-content: space-between;
  height: 48px;
  align-items: stretch;
}

.aeNfrn {
  display: flex;
  gap: 10px;
}

.xhm1QB {
  padding: 12px 8px;
  font-family: 'Source Sans 3', var(--font-family-base);
  font-size: 14px;
  font-weight: 500;
  line-height: 100%;
  letter-spacing: 0px;
  text-align: center;
  border: none;
  border-bottom: 2px solid transparent;
  background: none;
  color: var(--text-neutral-dark, #1f1f1f);
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  transition:
    color 0.2s ease-in-out,
    border-bottom-color 0.2s ease-in-out;
}

.xhm1QB:hover {
  color: var(--text-neutral-dark, #1f1f1f);
}

.T57uuG {
  color: var(--text-primary-medium, #d64000);
  font-weight: 600;
  border-bottom: 2px solid var(--stroke-primary-medium, #d64000);
  background-color: transparent;
}

.D7rHrm {
  color: var(--text-neutral-silver);
  cursor: not-allowed;
}

.D7rHrm:hover {
  color: var(--text-neutral-silver);
}

.GTN7KG {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 18px;
  height: 18px;
  margin-left: 6px;
  padding: 0 4px;
  border: 1px solid currentColor;
  border-radius: 50%;
  background: transparent;
  color: currentColor;
  font-size: 11px;
  font-weight: 600;
  line-height: 1;
}

.dwkU2l {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
}
`, "",{"version":3,"sources":["webpack://./../../packages/shared-ui/src/components/Tab/Tab.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,8CAA8C;EAC9C,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,sDAAsD;EACtD,8BAA8B;EAC9B,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,qDAAqD;EACrD,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,oCAAoC;EACpC,gBAAgB;EAChB,wCAAwC;EACxC,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR;;wCAEsC;AACxC;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,0CAA0C;EAC1C,gBAAgB;EAChB,8DAA8D;EAC9D,6BAA6B;AAC/B;;AAEA;EACE,iCAAiC;EACjC,mBAAmB;AACrB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,cAAc;EACd,8BAA8B;EAC9B,kBAAkB;EAClB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,OAAO;EACP,aAAa;EACb,aAAa;EACb,sBAAsB;AACxB","sourcesContent":[".container {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  height: 100%;\n  border-radius: 8px;\n  background-color: var(--surface-neutral-white);\n  box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.12);\n}\n\n.menu {\n  display: flex;\n  padding: 0 16px 0 12px;\n  box-shadow: inset 0 -1px 0 var(--line-subtle, #f2f2f2);\n  justify-content: space-between;\n  height: 48px;\n  align-items: stretch;\n}\n\n.menuItems {\n  display: flex;\n  gap: 10px;\n}\n\n.menuItem {\n  padding: 12px 8px;\n  font-family: 'Source Sans 3', var(--font-family-base);\n  font-size: 14px;\n  font-weight: 500;\n  line-height: 100%;\n  letter-spacing: 0px;\n  text-align: center;\n  border: none;\n  border-bottom: 2px solid transparent;\n  background: none;\n  color: var(--text-neutral-dark, #1f1f1f);\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  transition:\n    color 0.2s ease-in-out,\n    border-bottom-color 0.2s ease-in-out;\n}\n\n.menuItem:hover {\n  color: var(--text-neutral-dark, #1f1f1f);\n}\n\n.menuItemActive {\n  color: var(--text-primary-medium, #d64000);\n  font-weight: 600;\n  border-bottom: 2px solid var(--stroke-primary-medium, #d64000);\n  background-color: transparent;\n}\n\n.menuItemDisabled {\n  color: var(--text-neutral-silver);\n  cursor: not-allowed;\n}\n\n.menuItemDisabled:hover {\n  color: var(--text-neutral-silver);\n}\n\n.menuItemCount {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 18px;\n  height: 18px;\n  margin-left: 6px;\n  padding: 0 4px;\n  border: 1px solid currentColor;\n  border-radius: 50%;\n  background: transparent;\n  color: currentColor;\n  font-size: 11px;\n  font-weight: 600;\n  line-height: 1;\n}\n\n.content {\n  flex: 1;\n  min-height: 0;\n  display: flex;\n  flex-direction: column;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `VSslt7`,
	"menu": `JSTrZu`,
	"menuItems": `aeNfrn`,
	"menuItem": `xhm1QB`,
	"menuItemActive": `T57uuG`,
	"menuItemDisabled": `D7rHrm`,
	"menuItemCount": `GTN7KG`,
	"content": `dwkU2l`
};
module.exports = ___CSS_LOADER_EXPORT___;
